export default "__VITE_ASSET__oIU4f7G5__"